import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const HouseIcon = ({
  width = 24,
  height = 24,
  fill = '#52575C',
  strokeWidth = 0.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill}
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      d="M12.614 1.21c-.361-.28-.867-.28-1.228 0l-9 7C2.142 8.4 2 8.692 2 9v11c0 .796.316 1.559.879 2.121C3.44 22.684 4.204 23 5 23h14c.796 0 1.559-.316 2.121-.879.563-.562.879-1.325.879-2.121V9c0-.309-.142-.6-.386-.79l-9-7zM16 21h3c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V9.49l-8-6.223-8 6.222V20c0 .265.105.52.293.707.187.188.442.293.707.293h3v-9c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v9zm-6 0v-8h4v8h-4z"
      clipRule="evenodd"
    />
  </svg>
);
